/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup, Label, Input, Navbar,NavbarBrand } from 'reactstrap';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
//import { resourceData } from '../../../Resources/EULA/EULA.en-US';
import { postEULA_Acceptance,changePassword} from '../../../action/authenticateUser';  
import Footer from '../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import '../../../Assets/EnsembleStyles/AcceptLicense.css'
import NavbarLogo from '../../../Assets/images/green-trane-BA-logo.svg';
import {FaQuestionCircle} from 'react-icons/fa';


 class EULALicenseTerms extends Component {

    componentWillMount() {
        import('../../../Resources/EULA/EULA.en-US').then((resourceData) => {
            this.setState({
                license_content: resourceData.resourceData
            });
        });
    }


    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
         //EULA Successfull
               if (nextProps.login_response.loggedIn === true) {
                    this.setState({
                        loggedIn: nextProps.login_response.loggedIn,
                        token: nextProps.login_response.token,
                        user_type: nextProps.login_response.user_type,
                        error_msg: false, error_msg_type: null,
                        redirect :true, redirect_homepage :true
                    });
                }
                else if(nextProps.getLicenseinfo !== undefined){
                    this.setState({ 
                        license_info: nextProps.getLicenseinfo
                    });
                }
            //EULA Unsuccessfull   
                else {
                    this.setState({
                        redirect :true, redirect_logout :true
                    });
                }
            }
    }

    constructor(props) {
        super(props);
        this.state = {
            license_content: "",
            accept_terms: false,
            disabled:true,
            redirect:false,
            redirect_logout:false,
            redirect_homepage:false,
            username:"",
            password:"",
            new_password:null,
            acceptedEULA_state:  null, 
            license_info: [],
            loggedIn: false
        }
        this.logout = this.logout.bind(this);
        this.acceptedRedirecttoTenant = this.acceptedRedirecttoTenant.bind(this);
    }


    logout() {
        localStorage.setItem('USER_TOKEN', null);

        this.setState({
            redirect:true,
            redirect_logout:true,
        });

    }

     acceptedRedirecttoTenant() {
        let credentials = null;
        credentials = {
            "username": localStorage.getItem('EULA_U'),
            "password": localStorage.getItem('EULA_P'),
            "login_type": "property_manager",
            "EULA": true
        }
        if (credentials.username !== null &&credentials.username !== "" && credentials.username !== undefined && credentials.password !== null && credentials.password !== undefined && credentials.password !== "" ){
            this.props.changePassword(credentials);
        }
        else{
            localStorage.setItem('USER_TOKEN', null);
            this.setState({
                redirect:true,
                redirect_logout:true,
            });
        }
     }


    language(event) {
        let data = null;
        data = event.target.value
        import('../../../Resources/EULA/EULA.' + data).then((resourceData) => {
            this.setState({
                license_content: resourceData.resourceData
            });
        });
    }



    render() {
        
        let { license_content,redirect,redirect_logout,redirect_homepage,acceptedEULA_state,license_info,loggedIn } = this.state  //eslint-disable-line
        let license_content_data = license_content;
        let licensed_features = license_info.licensedFeatures;
        let islicensed = (licensed_features !== undefined) ? licensed_features.length : 0;
        
        if(redirect && redirect_logout ){
                    // close out any window that may be open with the name of "EnsembleVideoWindow"
        window.open('', 'EnsembleVideoWindow', 'resizable=1,status=yes,scrollbars=0,toolbar=0,titlebar=0,location=no,width=800,height=650,dialog=1,minimizable=1').close();

            return <Redirect to={"/"} />
        }

        else if(redirect && redirect_homepage && loggedIn){
            if(islicensed){
                if( licensed_features[0].licensed === true)
                    return <Redirect to={"/managetenant"} />
                else if( licensed_features[1].licensed === true)
                    return <Redirect to={"/ManageWorkOrder"}/>
                else
                    return <Redirect to={"/SystemAdmin/Administration"}/>
            }
            else{
                return <Redirect to={"/SystemAdmin/Administration"}/>
            }
        }

        return (

     <div className="license_Ensemble">

        <Navbar  className="Ensemble_Navbackground license_Ensemble_Navbackground" fixed={`top`} light expand="md">
          <NavbarBrand className="Ensemble_mainTitle" > <img src={NavbarLogo} alt="Trane Logo" className="Ensemble_trane_logo"/></NavbarBrand> 
        </Navbar> 

        <Navbar  className={"Ensemble_Navbackground license_Ensemble_Navbackground Ensemble_login_language_Navbackground"}  light expand="md">  </Navbar> 


                                    <div className="accept_license_Modal">
                                                    <div className="license_Modal_content_box">
                                                        <div className="license_header">
                                                            <h2 className="license_header_name">Please read the TERMS AND CONDITIONS - Licensed Material and Hosted Services thoroughly before accepting.</h2>
                                                            <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon link_cursor" />
                                                        </div>

                                                        <div className="license_header">
                                                            <select className="languages_select" onChange={event => { this.language(event) }}>
                                                                <option  value="en-US">English (United States)</option>
                                                                {/* <option value="es-MX">español (México)</option>
                                                                <option value="id-ID">Bahasa Indonesia (Indonesia)</option>
                                                                <option value="ja-JP">日本語 (日本)</option>
                                                                <option value="ko-KR">한국어(대한민국)</option>
                                                                <option value="pt-BR">português (Brasil)</option>
                                                                <option value="th-TH">ไทย (ไทย)</option> */}
                                                            </select>
                                                        </div>

                                                        <div>
                                                            <textarea className="license_Content" value={license_content_data} ></textarea>
                                                        </div>

                                                        <FormGroup tag="fieldset">
                                                                <FormGroup check>
                                                                    <Label check>
                                                                    <Input type="radio" name="radio1" className="link_cursor" defaultChecked  onClick={e => this.setState({  accept_terms: false,disabled:true})}/>{' '} No, I do not accept the Terms and Conditions
                                                                    </Label>
                                                                </FormGroup>
                                                                <FormGroup check>
                                                                    <Label check >
                                                                    <Input type="radio" name="radio1" className="link_cursor"   onClick={e => this.setState({ accept_terms: true, disabled:false })}/>{' '} Yes, I do accept the Terms and Conditions
                                                                    </Label>
                                                                </FormGroup>
                                                        </FormGroup>

                                                            <FormGroup row >
                                                                <Col sm={{ size: 12 }}>


                                                                    <Button className="btn-gray btn-md" onClick={this.logout}>Cancel</Button>
                                                                    <Button className="btn-success btn-md continue_btn" disabled={this.state.disabled} onClick={this.acceptedRedirecttoTenant}>Continue</Button>
                                                                </Col>
                                                            </FormGroup>
                                                    </div>
                                       </div>

                                         <Footer />
                    </div>
         
        );
    }
}

const mapStateToProps = state => {console.log(state.authService);
    return {
        login_response: state.authService,
        getLicenseinfo: state.InstallationsRootReducer.TenantWorkOrderLicense
    };
};

const mapDispatchToProps = dispatch => {
    return {
        postEULA_Acceptance: (credentials) => dispatch(postEULA_Acceptance(credentials)),
        changePassword: (credentials) => dispatch(changePassword(credentials)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EULALicenseTerms);



